import ValidatorResult from "../classes/validator.results";
export default class IsInValidationRule {
    name = 'isin';
    validate(validation, rule, value, object, manager) {
        //Message
        let tMessage = appHost.localizer.t("system.Validation.InValidValue");
        //Pre-Check
        if (!Array.isArray(rule.props)) {
            return new ValidatorResult(false, appHost.localizer.t("system.Validation.NoArray"));
        }
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        if (rule.props.indexOf(value) === -1)
            return new ValidatorResult(false, tMessage);
        return new ValidatorResult(true);
    }
}
